<!--
 * @Author: zhangmh31513
 * @Date: 2021-10-19 15:43:39
 * @LastEditTime: 2021-10-20 21:52:20
 * @LastEditors: zhangmh31513
 * @Description: 光子增加提示
 * @FilePath: \openplat-web\src\gtn\components\pnoton.vue
 * 有问题请第一时间来联系我
-->
<template>
  <transition name="h-tabs" mode="out-in">
    <div class="photon-wrap" v-if="show">
      <div class="img-wrap">
        <img src="@/assets/component/photon.png" alt="" />
        <div :style="{ color }">光子+{{ photonNum }}</div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "ScanToAnswer",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    // 字体颜色
    color: {
      type: String,
      default: "#FFE08B"
    },
    // 增加的光子数
    photonNum: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      msgBoxShow: false
    };
  },
  methods: {},
  watch: {
    show(val) {
      if (val) {
        // 2秒后消失
        setTimeout(() => {
          this.$emit("close");
        }, 2000);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.photon-wrap {
  position: fixed;
  top: 50%;
  left: 50%;
  margin: -101px 0 0 -101px;
  width: 202px;
  height: 202px;
  border-radius: 16px;
  background-color: rgba(0, 0, 0, 0.4);
  transform-origin: center;
  z-index: 1000;
  .img-wrap {
    width: 154px;
    height: 154px;
    background: url("../assets/component/photon_bg.png") center/120px no-repeat;
    position: relative;
    margin: 24px auto 0;
    div {
      width: 100%;
      text-align: center;
      font-size: 18px;
      line-height: 22px;
      bottom: 15px;
      left: 0;
      position: absolute;
    }
  }
  img {
    width: 53px;
    display: block;
    margin-bottom: 54px;
    position: absolute;
    top: 50px;
    left: 47px;
  }
}

.h-tabs-enter {
  transform: scale(0);
}
.h-tabs-leave-to {
  transform: scale(0);
}
.h-tabs-enter-to,
.h-tabs-leave {
  transform: scale(1);
}
.h-tabs-enter-active,
.h-tabs-leave-active {
  transition: transform 400ms;
}
</style>



// WEBPACK FOOTER //
// src/gtn/components/pnoton.vue